import SnappingOptions from '@arcgis/core/views/interactive/snapping/SnappingOptions';
import MapView from '@arcgis/core/views/MapView';
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';
import FeatureSnappingLayerSource from '@arcgis/core/views/interactive/snapping/FeatureSnappingLayerSource';
import {
  extractLayersForSnapping, initialSnappingSettings, persistSnappingSettings,
} from './snapping-states';

export const FEATURE_SNAPPING_LAYER_TRACK_INDICATOR = 'FEATURE_SNAPPING_LAYER_TRACK_INDICATOR';

const FulcrumSnappingOptions = (
  mapView: MapView,
  testableSnappingOptions?: SnappingOptions,
) => {
  const snappingOptionsInstance = testableSnappingOptions
    || new SnappingOptions(initialSnappingSettings());

  const listenForEnabled = snappingOptionsInstance.watch(
    'enabled', () => { persistSnappingSettings(snappingOptionsInstance); },
  );
  const listenForFeatureEnabled = snappingOptionsInstance.watch(
    'featureEnabled', () => { persistSnappingSettings(snappingOptionsInstance); },
  );
  const listenForSelfEnabled = snappingOptionsInstance.watch(
    'selfEnabled', () => { persistSnappingSettings(snappingOptionsInstance); },
  );

  const listenForOpenEvent = reactiveUtils.when(
    () => !mapView.updating,
    () => {
      const layerSources = extractLayersForSnapping(mapView);
      snappingOptionsInstance.featureSources.removeAll();
      snappingOptionsInstance.featureSources.addMany(layerSources);
      persistSnappingSettings(snappingOptionsInstance);
    },
    { once: true },
  );

  const listenForFeatureSourceChanges = snappingOptionsInstance.featureSources.on('change', (event) => {
    persistSnappingSettings(snappingOptionsInstance);

    // @ts-ignore
    const featureSources = event.target;

    featureSources.forEach((fs: FeatureSnappingLayerSource) => {
      // @ts-ignore
      if (!fs.FEATURE_SNAPPING_LAYER_TRACK_INDICATOR) {
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        fs.FEATURE_SNAPPING_LAYER_TRACK_INDICATOR = true;
        reactiveUtils.watch(
          () => fs.enabled,
          () => {
            persistSnappingSettings(snappingOptionsInstance);
          },
        );
      }
    });
  });

  const listenForClosingEvent = reactiveUtils.when(
    () => mapView.layerViews?.length === 0,
    () => {
      snappingOptionsInstance.removeHandles('snapping-options-handle-group');
    },
  );

  snappingOptionsInstance.addHandles([
    listenForEnabled,
    listenForFeatureEnabled,
    listenForSelfEnabled,
    listenForOpenEvent,
    listenForFeatureSourceChanges,
    listenForClosingEvent,
  ], 'snapping-options-handle-group');

  return snappingOptionsInstance;
};

export default FulcrumSnappingOptions;
